import {
  Alert,
  MantineColor,
  MantineSpacing,
  Text,
  useMantineTheme,
} from "@mantine/core"
import { IconAlertCircle } from "@tabler/icons-react"
import { CSSProperties, ReactNode } from "react"

type Props = {
  title?: ReactNode
  message: ReactNode
  fontSize?: "xs" | "sm" | "md" | "lg"
  bg?: MantineColor
  width?: string
  height?: string
  icon?: ReactNode
  my?: MantineSpacing | undefined
  messageStyles?: CSSProperties
  variant?: "error" | "info" | "success" | "admin" | "warning" | "primary"
}

export type InfoBoxProps = Props & {
  children?: ReactNode
}

export const InfoBox = ({
  title,
  message,
  fontSize = "sm",
  icon = <IconAlertCircle size="16" />,
  messageStyles = {},
  my,
  bg,
  width,
  height = "fit-content",
  variant = "info",
}: Props) => {
  const theme = useMantineTheme()
  return (
    <Alert
      title={title}
      icon={icon}
      fz={fontSize}
      styles={{
        body: { gap: 2 },
        message: messageStyles,
        wrapper: { alignItems: "center" },
        icon: { size: theme.other.icon.size, marginRight: theme.spacing.xxs },
      }}
      bg={bg}
      w={width}
      h={height}
      my={my}
      variant={variant}
    >
      {typeof message === "string" ? (
        <Text fz={fontSize}>{message}</Text>
      ) : (
        message
      )}
    </Alert>
  )
}
